import { Card, Col, Row } from "react-bootstrap";
import styled from "styled-components";

export const ManiWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #212428;
  transition: all 0.5s ease;
  box-sizing: border-box;
`;

export const HeaderWrapper = styled.header`
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  background: #212428;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  z-index: 1000;
  @media (max-width: 768px) {
    padding: 0 20px;
    height: 70px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  margin: 0 15%;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderImageWrapper = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
  border: 1px solid #fff;
  padding: 3px;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
    border-color: #fff;
  }
`;

export const NavigationWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    gap: 20px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 8px;

  @media (max-width: 600px) {
    display: block;
  }
`;

export const MobileMenu = styled.div<{ isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  background: #212428;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 999;
  transform: translateY(${(props) => (props.isOpen ? "0" : "-100%")});
  transition: transform 0.3s ease;

  @media (max-width: 600px) {
    display: block;
  }
`;

export const MobileNavLink = styled.a<{ isActive?: boolean }>`
  display: block;
  color: #fff;
  text-decoration: none;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 14px;
  padding: 15px 0;
  border-bottom: 1px solid #333;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    color: #ff014f;
  }

  &:last-child {
    border-bottom: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: ${(props) => (props.isActive ? "100%" : "0")};
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #ff014f;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const MobileDownloadButton = styled.button`
  width: 100%;
  background: linear-gradient(145deg, #ff014f, #e60045);
  color: white;
  border: none;
  padding: 15px 24px;
  border-radius: 25px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(145deg, #e60045, #ff014f);
  }
`;

export const NavLink = styled.a<{ isActive?: boolean }>`
  color: #fff;
  text-decoration: none;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  position: relative;
  outline: none;

  &:hover {
    color: #ff014f;
  }

  &:focus-visible {
    outline: 2px solid #ff014f;
    outline-offset: 4px;
    border-radius: 4px;
  }

  &::after {
    content: "";
    position: absolute;
    width: ${(props) => (props.isActive ? "100%" : "0")};
    height: 2px;
    bottom: -5px;
    left: 0;
    background-color: #ff014f;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const DownloadResumeButton = styled.button`
  background: linear-gradient(145deg, #ff014f, #e60045);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 1, 79, 0.3);
  outline: none;
  min-height: 44px;
  min-width: 44px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 1, 79, 0.4);
    background: linear-gradient(145deg, #e60045, #ff014f);
  }

  &:focus-visible {
    outline: 3px solid #fff;
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 12px;
  }
`;

export const SectionContainer = styled.div`
  max-width: 1500px;
  margin: 0 auto;
  width: 100%;
  padding: 0 15px;

  @media (min-width: 1400px) {
    max-width: 1356px;
  }

  @media (max-width: 992px) {
    padding: 0 10px;
  }

  @media (max-width: 600px) {
    padding: 0;
  }
`;

export const Rowwrapper = styled(Row)`
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  align-items: center;

  @media (max-width: 992px) {
    flex-direction: column-reverse;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const Colwrapper = styled(Col)`
  .contact_form {
    padding-left: 100px;
  }

  .banner_1 {
    object-fit: contain;
    width: 100%;
    max-width: 100%;
    height: auto;
    position: relative;
    transition:
      transform 0.3s ease,
      0.3s ease;
  }

  @media (min-width: 1200px) {
    .banner_1 {
      left: 10%;
      transition:
        transform 0.3s ease,
        0.3s ease;
    }
  }

  @media (max-width: 992px) {
    .banner_1 {
      max-width: 400px;
      margin: 0 auto 30px;
      left: 0;
    }
  }

  @media (max-width: 768px) {
    .banner_1 {
      max-width: 350px;
    }
    .contact_form {
      padding-left: 20px;
    }
  }

  @media (max-width: 600px) {
    .banner_1 {
      max-width: 300px;
      margin: 0 auto 20px;
    }
    .contact_form {
      padding-left: 0;
    }
  }
`;

export const FirstSectionWrapper = styled.section`
  display: flex;
  position: relative;
  min-height: 100vh;
  background: #212428;
  padding: 0 60px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  scroll-margin-top: 80px;

  @media (max-width: 992px) {
    padding: 40px 40px;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    scroll-margin-top: 70px;
  }

  @media (max-width: 600px) {
    padding: 30px 15px;
    text-align: center;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    scroll-margin-top: 70px;
  }
`;

export const CVButton = styled.button`
  display: flex;
  margin: 10px auto;
  border: 1px solid;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
  padding: 15px 20px;
  letter-spacing: 1px;
  background-color: transparent;
  border-color: #ff014f;
  font-weight: 600;
  color: #ff014f;
  font-size: 14px;
  transition: all 0.3s ease;
  cursor: pointer;
  outline: none;
  min-height: 44px;
  min-width: 44px;

  &:hover {
    background-color: #ff014f;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 1, 79, 0.3);
  }

  &:focus-visible {
    outline: 3px solid #ff014f;
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const StyledButton = styled.div`
  width: 55px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  border-radius: 6px;
  transition: all 0.4s;
  background: linear-gradient(145deg, #1e2024, #23272b);
  box-shadow:
    10px 10px 19px #1c1e22,
    -10px -10px 19px #262a2e;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  outline: none;
  min-height: 44px;
  min-width: 44px;

  img {
    filter: contrast(0%) brightness(1.5);
    position: relative;
    z-index: 2;
    width: 28px;
    transition: all 0.4s;
  }

  &:hover {
    background: #1e2024;
    transform: translateY(-5px);
    transition: all 0.4s;
    img {
      filter: contrast(0%) brightness(2);
      transition: all 0.4s;
    }
  }

  &:focus-visible {
    outline: 2px solid #ff014f;
    outline-offset: 2px;
  }

  @media (max-width: 600px) {
    width: 50px;
    height: 50px;
    line-height: 50px;

    img {
      width: 24px;
    }
  }

  @media (max-width: 400px) {
    width: 45px;
    height: 45px;
    line-height: 45px;

    img {
      width: 22px;
    }
  }

  .resume {
    font-weight: 1000;
  }
`;

export const SecondSectionWrapper = styled.section`
  display: flex;
  position: relative;
  height: auto;
  background: #212428;
  padding: 80px 60px;
  scroll-margin-top: 80px;

  .border-bottom-black {
    padding: 30px 60px 0 0;
    border-bottom: 0.5px solid #000;
  }

  @media (max-width: 600px) {
    padding: 40px 20px;
    text-align: center;
    align-items: center;
    scroll-margin-top: 70px;
  }
`;

export const SkillCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 1000px;
  @media (max-width: 600px) {
    width: 350px;
  }
`;

export const SkillsContainer = styled.div`
  margin: 15px 30px 70px 30px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;

export const SkillsCard = styled(Card)`
  padding: 30px 15px 25px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(145deg, #1e2024, #23272b);
  box-shadow:
    10px 10px 19px #1c1e22,
    -10px -10px 19px #262a2e;
  cursor: pointer;
  height: 150px;
  width: 130px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  outline: none;
  transition: all 0.4s ease;

  &:hover {
    transition: all 0.4s ease;
    background: linear-gradient(to right bottom, #212428, #16181c);
    border-color: rgba(24, 231, 204, 0.1);
    transform: translateY(-5px);
    .filter {
      transition: 0.5s;
      filter: grayscale(0);
    }
    .icon {
      transform: translateY(-5px);
      transition: 0.5s;
    }
  }

  &:focus-visible {
    outline: 2px solid #ff014f;
    outline-offset: 2px;
  }

  .filter {
    transition: 0.5s;
  }
  .icon {
    transition: 0.5s;
  }
`;

export const SkillsIconWrapper = styled.div`
  width: 70px;
  filter: grayscale(80);
`;

export const SkillsIcon = styled.img`
  font-size: 80px;
  color: #fff;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Skills = styled.h5`
  position: absolute;
  color: white;
  top: 165px;
  font-size: 15px;
  display: flex;
  width: 130px;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;
`;

export const ThirdSectionWrapper = styled.section`
  display: flex;
  position: relative;
  height: auto;
  background: #212428;
  padding: 80px 60px;
  scroll-margin-top: 80px;

  .border-bottom-black {
    padding: 40px 60px 0 0;
    border-bottom: 0.5px solid #000;
  }

  @media (max-width: 600px) {
    padding: 40px 20px;
    text-align: center;
    align-items: center;
    scroll-margin-top: 70px;
  }
`;

export const CardWrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 400px;
  padding: 10px 25px;
  cursor: pointer;
  background: linear-gradient(145deg, #1e2024, #23272b);
  color: white;
  border: none;
  margin: 10px auto;
  position: relative;
  transition: 0.5s all;
  border: 1px solid rgb(51, 54, 56);
  &:hover {
    transition: 0.5s all;

    transform: translateY(-10px);
    .title {
      color: rgb(94 234 212 / 1);
    }
  }
  @media (max-width: 600px) {
    width: 350px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: auto;
  overflow: hidden;
  margin-bottom: 27px;

  top: 0;
  img {
    object-fit: contain;
    width: 100%;
    height: 180px;
    min-height: 180px !important;
    min-width: 180px !important;
    border-radius: 10px;
  }
`;

export const HiglihWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  font-size: 0.7rem;
  padding: 0.25rem 0.6rem;
  font-weight: 500;
  background-color: #ff014f;
  border-radius: 9999px;
  color: #fff;
  line-height: 1.25rem;
  margin-top: 0.5rem;
  margin-right: 0.375rem;
  @media (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ProfileCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  justify-content: start;
  margin: 0 auto;
  min-width: 100%;
  overflow: auto;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: #878e99;
  background: #212428;
  font-family: "Poppins", sans-serif;
  padding: 40px 0 !important;
`;

export const FourthSectionWrapper = styled.section`
  display: flex;
  position: relative;
  height: auto;
  background: #212428;
  padding: 80px 60px;
  scroll-margin-top: 80px;

  .border-bottom-black {
    padding: 40px 60px 0 0;
    border-bottom: 0.5px solid #000;
  }

  button {
    background-color: #3b3e41;
    padding: 10px 20px;
    color: #fff;
    font-family: "Poppins", sans-serif;
    box-shadow: none;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    outline: none;
    min-height: 44px;
    min-width: 44px;

    &:hover {
      background-color: #ff014f;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 1, 79, 0.3);
    }

    &:focus-visible {
      outline: 3px solid #ff014f;
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  @media (max-width: 600px) {
    padding: 40px 20px;
    text-align: center;
    align-items: center;
    scroll-margin-top: 70px;
  }
  .textae {
    margin: 15px 0;
    font-family: "Poppins", sans-serif;
    background-color: #3b3e41;
    width: 90%;
    border-radius: 5px;
    border: 2px solid transparent;
    padding: 10px;
    color: #fff;
    outline: none;
    transition: all 0.3s ease;
    resize: vertical;

    &::placeholder {
      padding: 10px;
      color: rgba(255, 255, 255, 0.6);
      font-family: "Poppins", sans-serif;
    }

    &:focus {
      color: #fff;
      background-color: #3b3e41;
      border: 2px solid #ff014f;
      box-shadow: 0 0 0 3px rgba(255, 1, 79, 0.1);
    }

    &:focus-visible {
      outline: 2px solid #ff014f;
      outline-offset: 2px;
    }
  }
`;

export const Form = styled.input`
  margin: 15px 0;
  font-family: "Poppins", sans-serif;
  background-color: #3b3e41;
  width: 90%;
  height: 50px;
  padding: 10px;
  border: 2px solid transparent;
  border-radius: 5px;
  color: #fff;
  outline: none;
  transition: all 0.3s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
    padding: 10px;
    font-family: "Poppins", sans-serif;
  }

  &:focus {
    color: #fff;
    background-color: #3b3e41;
    border: 2px solid #ff014f;
    box-shadow: 0 0 0 3px rgba(255, 1, 79, 0.1);
  }

  &:focus-visible {
    outline: 2px solid #ff014f;
    outline-offset: 2px;
  }
`;
